/**
 * SubscriptionRenewal scene slice
 *
 * @author Carlos Silva <csilva@ubiwhere.com>
 *
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export default createSlice({
  name: 'SubscriptionRenewal',
  initialState,
  reducers: {
    onMount: () => {},
    onUnmount: () => {},
  },
});
